import { SANKEY_COLUMN_FILTER } from '../constants/actionTypes';

export const groupFilter = {
  area_description: {
    index: 0,
    initialSelected: false,
    name: 'Area Description',
  },
  building_floor: {
    index: 1,
    initialSelected: false,
    name: 'Building Floor',
  },
  area_functional: {
    index: 2,
    initialSelected: true,
    name: 'Functional Area',
  },
  area_room: {
    index: 3,
    initialSelected: true,
    name: 'Room',
  },
  equipment_group: {
    index: 4,
    initialSelected: true,
    name: 'Equipment Group',
  },
  equipment_type: {
    index: 5,
    initialSelected: true,
    name: 'Equipment Type',
  },
};

const initialFilter = Object.keys(groupFilter)
  .filter(item => groupFilter[item].initialSelected)
  .map(item => item);

export default (state = initialFilter, action) => {
  switch (action.type) {
    case SANKEY_COLUMN_FILTER:
      const selectedFilter = action.payload;
      const index = state.indexOf(selectedFilter);

      // todo: reduce complexity with sub reducers
      if (index > -1 && state.length <= 2) {
        return state;
      }

      if (index > -1) {
        return [...state.slice(0, index), ...state.slice(index + 1)];
      }

      const selectedSorted = [...state, selectedFilter].reduce(
        (obj, element) => {
          obj[element] = groupFilter[element].index;
          return obj;
        },
        {}
      );

      return Object.keys(selectedSorted).sort(
        (a, b) => selectedSorted[a] - selectedSorted[b]
      );

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/sankeyColumnFilter.js